(function () {
  if (window.__elvtdPartnersCategoryInit) return;
  window.__elvtdPartnersCategoryInit = true;

  var closeIconSvg =
    '<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M8 8L25 25M25 8L8 25" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
    '</svg>';

  var modalOverlay = null;

  function buildModal() {
    var overlay = document.createElement('div');
    overlay.className = 'elvtd-partners-modal-overlay';
    overlay.setAttribute('data-partners-modal-overlay', '');
    overlay.innerHTML =
      '<div class="elvtd-partners-modal" role="dialog" aria-modal="true">' +
      '<button type="button" class="elvtd-partners-modal__close" aria-label="Close" data-partners-modal-close>' +
      closeIconSvg +
      '</button>' +
      '<div class="epc-header">' +
      '<div class="epc-header__row">' +
      '<div class="heading-wrapper"><h2 class="elvtd-heading-no-grad" data-partners-modal-title></h2></div>' +
      '<p class="epc-header__desc" data-partners-modal-subtitle></p>' +
      '</div>' +
      '</div>' +
      '<div class="epc-brands" data-partners-modal-brands></div>' +
      '<button type="button" class="epc-show-all" data-partners-modal-close>SHOW LESS</button>' +
      '</div>';
    document.body.appendChild(overlay);
    return overlay;
  }

  function ensureModal() {
    if (!modalOverlay) modalOverlay = buildModal();
    return modalOverlay;
  }

  function openModal(button) {
    var overlay = ensureModal();
    var titleEl = overlay.querySelector('[data-partners-modal-title]');
    var subtitleEl = overlay.querySelector('[data-partners-modal-subtitle]');
    var brandsEl = overlay.querySelector('[data-partners-modal-brands]');
    var showLessBtn = overlay.querySelector('.epc-show-all');

    titleEl.innerHTML = button.getAttribute('data-modal-title') || '';

    var subtitle = button.getAttribute('data-modal-subtitle') || '';
    subtitleEl.textContent = subtitle;
    subtitleEl.hidden = !subtitle;

    if (showLessBtn) {
      showLessBtn.textContent = button.getAttribute('data-modal-btn-label') || 'SHOW LESS';
    }

    var sectionId = button.getAttribute('data-section-id');
    var jsonScript = sectionId ? document.getElementById('elvtd-brands-' + sectionId) : null;
    var brands = [];
    if (jsonScript) {
      try {
        brands = JSON.parse(jsonScript.textContent);
      } catch (e) {
        brands = [];
      }
    }

    brandsEl.innerHTML = '';
    brands.forEach(function (name) {
      if (!name) return;
      var span = document.createElement('span');
      span.className = 'epc-badge';
      span.textContent = name;
      brandsEl.appendChild(span);
    });

    overlay.classList.add('is-open');
    document.body.classList.add('elvtd-partners-modal-open');
  }

  function closeModal() {
    if (!modalOverlay) return;
    modalOverlay.classList.remove('is-open');
    document.body.classList.remove('elvtd-partners-modal-open');
  }

  document.addEventListener('click', function (e) {
    var showAllBtn = e.target.closest('.elvtd-partners-category__show-all');
    if (showAllBtn) {
      openModal(showAllBtn);
      return;
    }

    if (e.target.closest('[data-partners-modal-close]')) {
      closeModal();
      return;
    }

    if (modalOverlay && e.target === modalOverlay) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
